import React from 'react';
import backgroundImg from 'on_web/assets/images/general-welcome-background.svg';

import ContainerWithBackground from 'on_web/components/shared/Common/ContainerWithBackgroundImg';

import { Box } from '@material-ui/core';

export default function SplashScreen(props) {
  const { children } = props;

  return (
    <ContainerWithBackground
      image={backgroundImg}
      maxWidth={'957px'}
      maxHeight={'830px'}
      height={'90vh'}
      width={'100vw'}
      marginTop={'0vh'}
    >
      <Box
        mr={{ xs: 2 }}
        ml={{ xs: 2 }}
        color="#ffffff"
        maxWidth="350px"
        position="relative"
        left={{ sm: '20%', xl: '20%', md: '20%', lg: '20%' }}
        right={{ xs: '5%' }}
        top={{ sm: '10%', xs: '30%' }}
      >
        {children}
      </Box>
    </ContainerWithBackground>
  );
}
